$(window).load(function(){
$(document).ready(function(){

    $(".header-nav_toggle").click(function() {
        $(this).toggleClass('opened');
        $('.header-navigation').toggleClass('opened');
        return false;
    });
    $(document).click(function() {
        // Закрываем всё
        $(".header-nav_toggle").removeClass('opened');
        $('.header-navigation').removeClass('opened');
    });
    $(window).resize(function(){
        // Закрываем всё
        $(".header-nav_toggle").removeClass('opened');
        $('.header-navigation').removeClass('opened');
    });


    $(".js-open-form").colorbox({className: "colorbox-cleared" });
    $(".practice-list .images a").colorbox({maxWidth:'95%', maxHeight:'95%', rel: 'practice-list .images a'});


    //jQuery('.reviews-list .data').matchHeight();

    $('.reviews-list').owlCarousel({
        loop: true,
        nav: true,
        margin: 0,
        smartSpeed: 700,
        navText: ['',''],

        responsive:{
            0:{
                items: 1
            },
            750:{
                items: 2
            },
            990:{
                items: 3
            },
            1200:{
                items: 4
            }
        }
    });



    /*if ($.cookie("cookie-info-hide") == undefined) {
        $(".cookie-info").show();
    }
    $(".cookie-info_close").click(function() {
        $(".cookie-info").hide();
        $.cookie("cookie-info-hide", 1, { expires: 30, path: '/' });
    });*/
});
});
